import React, { useEffect } from "react"
import useapi from "@/hooks/useapi"
import { fetchDagsExtract } from "@/api/dags.api"
import { Spin, Table, TableColumnsType, Tag } from "antd"
import JsonViewer from "@pages/dags/metadata/jsonViewer"
import { useGetDagsPublish, useGetDagsLoad, useGetDagsTransform } from "@/hooks/useDags"
import { IPublish, ILoad, ITransform } from "@/types/dags"


const PublishDags = ({ dagId }: { dagId: string }) => {
  const { data, isLoading } = useGetDagsPublish(dagId)

  if (isLoading) {
    return <Spin />
  }

  const columns: TableColumnsType<IPublish> = [
    {
      title: "Id",
      key: "_id",
      dataIndex: "_id",
    },
    {
      title: "Completed",
      key: "hasCompleted",
      dataIndex: "hasCompleted",
      render: (value) => (
        <span>
          {value ? (
            <Tag color="#87d068">True</Tag>
          ) : (
            <Tag color="#f50">False</Tag>
          )}
        </span>
      ),
    },
    {
      title: "Date",
      key: "dateCreated",
      dataIndex: "dateCreated",
      render: (value) => new Date(value).toLocaleString("en-AU"),
    },
    {
      title: "Operation",
      render: (_, form) => {
        return <JsonViewer data={form} />
      },
    },
  ]

  if (data) {
    return (
      <div>
        <Table
          size={"small"}
          columns={columns}
          dataSource={data}
          rowKey={"_id"}
          footer={() => (
            <div style={{ padding: 0, marginTop: 7 }}>
              <p style={{ alignSelf: "center", textAlign: "right" }}>
                Total items: {data.length}
              </p>
            </div>
          )}
        />
      </div>
    )
  }

  return null
}

export default PublishDags
